import { render, staticRenderFns } from "./formatar.vue?vue&type=template&id=3e59b5c0&"
import script from "./formatar.vue?vue&type=script&lang=js&"
export * from "./formatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports